import React from 'react';
import { useField, useFormikContext } from 'formik';
import { Form } from 'react-bootstrap';

const CheckboxField = (props) => {
    const { setFieldValue } = useFormikContext();
    const [field] = useField(props);

    return (
        <Form.Check
            {...field}
            {...props}
            type="checkbox"
            checked={props.value}
            onChange={(event) => {
                setFieldValue(field.name, event.target.checked);
            }}
        />
    );
};

export default CheckboxField;
